import React from 'react';
import { GridSplash, LoadingIndicator } from '../../atoms';

interface Props {
    width?: number;
    height?: number;
    as?: 'div' | 'tr';
}
export default function GridLoadingSplash({ width, height, as }: Props) {

    const Splash = () => (
        <GridSplash
            width={width}
            height={height}
            icon={<LoadingIndicator size={5} />}
        />
    );

    return (
        <>
            {
                (as === 'div') ?
                    <div style={{ height: height }}>
                        <Splash />
                    </div> :
                    (as === 'tr') ?
                        <tr>
                            <td className={'p-0 border-0'}>
                                <Splash />
                            </td>
                        </tr> :
                        <tr>
                            <td className={'p-0 border-0'}>
                                <Splash />
                            </td>
                        </tr>
            }
        </>
    )
}